// The languages a customer can choose in the booking portal; the payment page follows them.
export const customerLanguages = [
  'en',
  'de',
  'sv',
  'es',
  'fr',
  'nb',
  'pl',
  'lv',
  'ru',
  'nl',
  'fi',
  'pt',
  'cs',
  'el',
  'sl',
  'ca',
] as const;
